<template>
  <a-modal
    title="指定库位"
    :visible="visible"
    :width="520"
    class="bath-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model :form="formData" v-bind="layout" layout="inline">
      <a-row>
        <a-col :span="16">
          <a-form-model-item label="选择库位">
            <a-select
              v-model="formData.storehouseId"
              :get-popup-container="(triggerNode) => (triggerNode.parentElement)"
              allow-clear
              show-search
              placeholder="请选择指定库位"
            >
              <a-select-option
                v-for="item in loactionList"
                :key="item.locationId"
                :value="item.locationId"
              >{{item.locationCode}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getStorehousePage } from '../api';

export default {
  name: 'Location',
  data() {
    return {
      visible: false,
      chooseIndex: null,
      formData: {},
      layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
      },
      loactionList: [],
    }
  },
  methods: {
    async show(index, row) {
      const res = await getStorehousePage({
        goodsId: row.skuId
      })
      this.loactionList = res
      this.visible = true;
      this.formData = {...row};
      this.chooseIndex = index
    },
    handleOk() {
      if (this.formData.storehouseId) {
        const current = this.loactionList.find(item => item.locationId === this.formData.storehouseId)
        this.$set(this.formData, 'storehouseCode', current?.locationCode || '')
      }
      this.$emit('changeLocation', this.chooseIndex, this.formData);
      this.handleCancel()
    },
    handleCancel() {
      this.visible = false;
    },
  }
}
</script>

<style lang="less" scoped>
  .bath-modal {
    .ant-form-item {
      width: 100%;
      .ant-calendar-picker {
        width: 100%;
      }
    }
  }
  </style>